import {
  IResearchWorkFilters,
  IResearchWorkItem,
} from "features/Research/types";
import { apiClient } from "lib/apiClient";

export const getResearchWorkItems = async (
  filters: IResearchWorkFilters = {}
): Promise<IResearchWorkItem[]> => {
  const response = await apiClient.get("/research/work-items", {
    params: filters,
  });

  return response.data;
};
